/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import { useMobileDetect } from 'hooks/useMobileDetect';

import Text from './Text';
import { Container, Title, Head, HeadItem, Body, Item, MobileWrap } from './styles';

const Table = ({ type, name, head, children }) => {
  const isMobile = useMobileDetect();

  return (
    <Container>
      <Title>{name}</Title>
      {isMobile &&
        type === 'dataSources' &&
        children.map((item, key) => (
          <MobileWrap key={key}>
            <Head $amount={2}>
              <HeadItem>{head[0]}</HeadItem>
              <HeadItem $isCentered>{head[2]}</HeadItem>
            </Head>
            <Item $amount={2}>
              <Text>{item[0]}</Text>
              <Text isCentered>{item[2]}</Text>
            </Item>
            <HeadItem $paddingTop="0">{head[1]}</HeadItem>
            <Text>{item[1]}</Text>
          </MobileWrap>
        ))}
      {isMobile &&
        type === 'dataObject' &&
        children.map((item, key) => (
          <MobileWrap key={key}>
            <div>
              <HeadItem>{head[0]}</HeadItem>
              <Text>{item[0]}</Text>
            </div>
            <div>
              <HeadItem $paddingTop="0">{head[1]}</HeadItem>
              <Text>{item[1]}</Text>
            </div>
          </MobileWrap>
        ))}
      {!isMobile && (
        <div>
          <Head $type={type}>
            {head.map((item, key) => (
              <HeadItem key={key} $isCentered={type === 'dataSources' && key === 2}>
                {item}
              </HeadItem>
            ))}
          </Head>
          <Body>
            {children.map((item, key) => (
              <Item key={key} $type={type}>
                {item.map((text, index) => (
                  <Text key={index} isCentered={type === 'dataSources' && index === 2}>
                    {text}
                  </Text>
                ))}
              </Item>
            ))}
          </Body>
        </div>
      )}
    </Container>
  );
};

Table.propTypes = {
  type: PropTypes.oneOf(['dataSources', 'dataObject']).isRequired,
  name: PropTypes.string.isRequired,
  head: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  children: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.array]).isRequired)
      .isRequired
  ).isRequired,
};

export default Table;
